import React from "react";
import {
  useInstallFullStory,
  useIdentifyToFullStory,
} from "@zapier/react-fullstory";

/**
 * User object expected by FullStory for identification.
 * Matches the User type from auth.ts but with fullName field for FullStory API compatibility.
 */
interface FullStoryUser {
  id: string;
  fullName: string;
  email: string;
  [key: string]: string;
}

interface Props {
  user?: {
    id: string;
    name: string;
    email: string;
  };
  disableFullStory?: boolean;
}

interface FullStoryIdentifyProps {
  user: FullStoryUser;
}

const FullStoryIdentify = ({ user }: FullStoryIdentifyProps) => {
  useIdentifyToFullStory(user);

  return null;
};

const FullStoryContainer = ({ user, disableFullStory }: Props) => {
  const shouldRecordFullStory = !disableFullStory;

  useInstallFullStory({ isDisabled: !shouldRecordFullStory });

  if (shouldRecordFullStory && user) {
    // Transform user to FullStory format (name -> fullName)
    const fullStoryUser: FullStoryUser = {
      id: user.id,
      fullName: user.name,
      email: user.email,
    };

    return <FullStoryIdentify user={fullStoryUser} />;
  }

  return null;
};

export default FullStoryContainer;
